import { useMemo } from 'react'
import AuthHelper from 'helpers/auth_helper'

const useReferrerRole = () => {
  return useMemo(() => {
    if (AuthHelper.hasBothProfileRoles) return 'talent'
    if (AuthHelper.hasClientProfile) return 'client'
    return 'client'
  }, [])
}

export default useReferrerRole
